export function normalizeBookFileId(value) {
    if (value == null) return null
    if (typeof value !== 'string' && typeof value !== 'number') throw new Error('Invalid Book file ID')
    return String(value).trim() || null
}

export function buildBookUrl(baseUrl, fileId) {
    const url = new URL(baseUrl)
    if (!['https:', 'http:'].includes(url.protocol)) throw new Error('Invalid Book URL')
    const id = normalizeBookFileId(fileId)
    if (id === null) url.searchParams.delete('fileId')
    else url.searchParams.set('fileId', id)
    return url.href
}

// 닷북 매뉴얼 주소 — 닷북은 하위 경로(/book)에 배포되므로 주소의 경로를 살려 그 아래 /manual 을 붙인다.
export function buildBookManualUrl(baseUrl) {
    const url = new URL(baseUrl)
    if (!['https:', 'http:'].includes(url.protocol)) throw new Error('Invalid Book URL')
    url.pathname = `${url.pathname.replace(/\/+$/, '')}/manual`
    url.search = ''
    url.hash = ''
    return url.href
}
